import { __decorate } from "tslib";
import { Messenger } from './events.js';
import { define } from './mixins.js';
export const isProduction = typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production', logEvents = isProduction ?
    ['error', 'info'] :
    ['error', 'warn', 'debug', 'info', 'log'];
let Logger = class Logger extends Messenger {
    constructor() {
        super(...arguments);
        this.counter = {};
    }
    logToConsole(level, filter) {
        return this.on(level, (topic, msg, props) => {
            if (!filter || filter.test(topic)) {
                const args = [`[${topic}] ${msg}`];
                for (let name in props) {
                    args.push(`\n\t${name}:`, toString(props[name]));
                }
                console[level].apply(console, args);
            }
        });
    }
    throwOn(level, filter) {
        return this.on(level, (topic, msg, props) => {
            if (!filter || filter.test(topic)) {
                throw new Error(`[${topic}] ${msg}`);
            }
        });
    }
    count(level, filter) {
        return this.on(level, (topic, msg, props) => {
            if (!filter || filter.test(topic)) {
                this.counter[level] = (this.counter[level] || 0) + 1;
            }
        });
    }
    on(a, b) {
        return super.on(a, b);
    }
};
Logger = __decorate([
    define
], Logger);
export { Logger };
let toString = typeof window === 'undefined' ?
    something => {
        if (something && typeof something === 'object') {
            const { __inner_state__ } = something, value = __inner_state__ || something, isArray = Array.isArray(value);
            const body = isArray ? `[ length = ${value.length} ]` : `{ ${Object.keys(value).join(', ')} }`;
            return something.constructor.name + ' ' + body;
        }
        return JSON.stringify(something);
    }
    : x => x;
export const logger = new Logger();
if (typeof console !== 'undefined') {
    for (let event of logEvents) {
        logger.logToConsole(event);
    }
}
export const throwingLogger = new Logger();
throwingLogger.throwOn('error').throwOn('warn');
export const log = logger.trigger.bind(logger);
//# sourceMappingURL=logging.js.map